import type { GoogleMapInstance, GoogleMapsApi, LatLngLiteral, MapPolyline } from './googleMaps'

/**
 * Trajet suggéré par les rues (tireté avec flèches de sens). Distinct de la trace GPS enregistrée : couleur et
 * motif différents, pour qu'il ne passe jamais pour un trajet réellement parcouru ni pour une obligation.
 */
export interface SuggestedPathLayer {
  update: (path: LatLngLiteral[] | null) => void
  destroy: () => void
}

export function createSuggestedPathLayer(api: GoogleMapsApi, map: GoogleMapInstance, color = '#C084FC'): SuggestedPathLayer {
  let line: MapPolyline | null = null
  const clear = () => {
    line?.setMap(null)
    line = null
  }
  return {
    update(path) {
      clear()
      if (!path || path.length < 2) return
      line = new api.Polyline({
        map,
        path,
        clickable: false,
        strokeOpacity: 0,
        icons: [
          { icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, strokeColor: color, strokeWeight: 5, scale: 3 }, offset: '0', repeat: '14px' },
          {
            icon: { path: api.SymbolPath.FORWARD_CLOSED_ARROW, strokeColor: '#fff', strokeWeight: 1, fillColor: color, fillOpacity: 1, scale: 3.5 },
            offset: '40px',
            repeat: '110px',
          },
        ],
      })
    },
    destroy: clear,
  }
}
